import { handleRoute } from "../https";

export async function findCardEmployee({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/card`,
  });
  return res;
}

export async function findCard({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/card`,
  });
  return res;
}

export async function toggleCard({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/employees/${employeeId}/card/toggle-card`,
  });
  return res;
}

export async function requestDuplicate({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/employees/${employeeId}/card/request-duplicate`,
  });
  return res;
}
